import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input() tooltipText:string;
  @Input() nickName:string;
  @Input() showFrontOf:boolean;

}
